import {lazy} from '@aboutyou/lazy-imports';
import {LoadingPageSpinner} from '@aboutyou/ui-components';
import React from 'react';

export const PremiumPage = lazy(
  () => import('./PremiumPage.eager').then(mod => ({default: mod.PremiumPage})),
  {
    fallback: <LoadingPageSpinner />,
    aboveTheFold: true,
  },
);
